import axios from 'axios'
import router from "../../router";

export default {
    namespaced: true,
    state: {
        want_to_delete: false,
        is_deleting_in_server: false,
        compliance_id: undefined,
        process_id: undefined,
    },
    getters: {
        getWantToDelete(state) {
            return state.want_to_delete
        },
        getIsDeletingInServer(state) {
            return state.is_deleting_in_server;
        },
        getComplianceId(state) {
            return state.compliance_id;
        },
        getProcessId(state) {
            return state.process_id;
        }
    },
    mutations: {
        setWantToDelete(state, want_to_delete) {
            state.want_to_delete = want_to_delete;
        },
        setIsDeletingInServer(state, is_deleting_in_server) {
            state.is_deleting_in_server = is_deleting_in_server;
        },
        setComplianceId(state, compliance_id) {
            state.compliance_id = compliance_id;
        },
        setProcessId(state, process_id) {
            state.process_id = process_id;
        }
    },
    actions: {
        deleteCompliance(context, payload) {
            console.log('payload', payload)
            context.commit('setWantToDelete', true);
            context.commit('setComplianceId', payload.compliance_id);
            context.commit('setProcessId', payload.process_id);
        },
        resetAll(context) {
            context.commit('setWantToDelete', false);
            context.commit('setComplianceId', undefined);
            context.commit('setIsDeletingInServer', false);
            context.commit('setProcessId', undefined);
        },
        deleteComplianceOnServer(context) {
            return new Promise((resolve, reject) => {
                context.commit('setIsDeletingInServer', true);
                axios.delete('/auth/compliance/delete/' + context.getters['getComplianceId']).then(response => {
                    console.log('data delete', response.data);
                    if (response.data.status === 'success') {
                        Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                        router.go({
                            name: 'processes-detail', params: {
                                'id': context.getters['getProcessId']
                            }
                        });
                    }
                    resolve(response);
                }).catch(error => {
                    reject(error);
                }).finally(() => {
                    context.dispatch('resetAll');
                });
                ;
            });
        }
    }
}